import Vue from 'vue'
import { MutationTree } from 'vuex/types/index'
import { ApplicationsState, ApplicationResource } from './applications.types'

const mutations: MutationTree<ApplicationsState> = {
  SET_APPLICATIONS (state, applications: ApplicationResource[]) {
    applications.forEach(application => Vue.set(state.data, application.id, application))
  },

  SET_APPLICATION (state, application: ApplicationResource) {
    Vue.set(state.data, application.id, application)
  },

  SET_APPLICATION_META (state, meta) {
    Vue.set(state, 'meta', meta)
  }
}

export default mutations

